<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'un Rendez-vous</span>
      <google-sync-button slot="left-action"></google-sync-button>
      <div class="column is-paddingless is-border-left" slot="left-action">
        <router-link :to="{name: 'CalendarDayView'}" class="page-header-btn is-small">
            <span class="icon is-small">
              <i class="fal fa-calendar-alt"></i>
            </span>
          <span>{{today | prettyDate}}</span>
        </router-link>
      </div>
    </sticky>
    <div class="columns is-gapless is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-8 is-9-widescreen is-padding-right">
        <div class="has-bg-white is-border">
          <calendar-form @submit="submit"
                         @cancel="cancel"
                         :source="rdv"
                         :confirmed-rdv="confirmedRdv"
                         :loading="loading"
                         v-if="!loading"
          ></calendar-form>
        </div>
      </div>
      <div class="column is-4 is-3-widescreen">
        <div class="is-border">
          <div class="columns is-column is-border-bottom">
            <div class="column has-bg-light-darken-1 columns is-vcentered is-gapless">
              <div class="column is-narrow">
                <span class="icon is-large has-text-grey"><i class="fal fa-info-circle fa-3x">&nbsp;</i></span></div>
              <div class="column"><span class="title is-4">&nbsp;<b>Information</b></span></div>
            </div>
            <div class="column has-text-grey" v-if="tab === 'rdv'">
              <p>1.Sélectionnez le numéro de rendez-vous. (ex: R0 pour un premier contact téléphonique, R1 pour un premier rendez-vous physique, etc.)</p>
              <p class="is-margin-top-small">2.Optionnel : Vous avez la possibilité d’associer un vendeur au rendez-vous en décochant le bouton ‘Ce rdv est pour moi’.</p>
              <p class="is-margin-top-small">3.Sélectionnez le contact avec lequel vous souhaitez enregistrer le rendez-vous.</p>
              <p class="is-margin-top-small">4.Choisissez la date et l’heure de votre rendez-vous ainsi que sa durée.</p>
              <p class="is-margin-top-small">5.Vous avez la possibilité d’entrer un lieu / une adresse pour ce rendez-vous, vous permettant de voir où il se situe directement depuis l’espace de gestion des rendez-vous.</p>
              <p class="is-margin-top-small">6.Validez votre rendez-vous pour le créer. Un mail de confirmation du rendez-vous sera automatiquement envoyé aux utilisateurs concernés.</p>
            </div>
            <div class="column has-text-grey" v-if="tab === 'confirm'">
              <p><b>Vous pouvez exporter vos rendez-vous pour les retrouver sur vos agendas préférés. </b></p>
              <p class="is-margin-top-small">Passez par l'exportation vers l'agenda Google pour retrouver vos rendez-vous dans votre Google Agenda (vous devrez vous connecter pour effectuer cette action)</p>
              <p class="is-margin-top-small">Passez par l'exportation vers un autre agenda pour télécharger l'événement sur votre ordinateur (en .ics)</p>
            </div>
            <!-- <div class="column is-border-top">
              <p><a class="has-text-grey has-text-weight-medium" >Lien Guide d'utilisation</a></p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CalendarForm from './CalendarForm'
  import GoogleSyncButton from './GoogleSyncButton'
  import moment from 'moment'

  export default {
    name: 'CalendarCreate',
    components: {CalendarForm, GoogleSyncButton},
    data () {
      return {
        loading: false,
        tab: 'rdv',
        confirmedRdv: null,
        today: new Date(),
        rdv: null,
        isReported: false
      }
    },
    methods: {
      submit (newRdv) {
        this.loading = true
        this.$set(this, 'tab', 'confirm')
        this.$api.rdvService.post(newRdv).then(r => {
          this.loading = false
          // this.rdv = r.data
          this.confirmedRdv = r.data
          let key = moment(this.confirmedRdv.date).format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', {event: this.confirmedRdv, key, type: 'rdvs'})
          // this.$router.push({name: 'CalendarMonthView'})
          this.$notify({
            type: 'is-success',
            text: 'Rdv créé.'
          })
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du rendez-vous'
          })
        })
      },
      getRdv (id) {
        this.loading = true
        this.$api.rdvService.getOne(id).then(r => {
          let newRdv = r.data
          if (newRdv.successful) {
            let type = Number(newRdv.rdv_type.split('')[1]) + 1
            if (type < 4) newRdv.rdv_type = `R${type}`
          }
          newRdv.title = null
          newRdv.google_calendar_id = null
          newRdv.google_event_id = null
          if (!this.isReported) {
            newRdv.date = moment().startOf('hour').add(1, 'hour').toDate()
            newRdv.end_date = moment().startOf('hour').add(2, 'hour').toDate()
          }
          newRdv.reports = []
          newRdv.guests = []
          newRdv.guests_email = []
          newRdv.guests_name = []
          newRdv.note = ''
          newRdv.report_note = ''
          newRdv.deferred = false
          newRdv.canceled = false
          newRdv.successful = false
          newRdv.previous_rdv = newRdv.pk
          delete newRdv.pk
          delete newRdv.created_on
          this.rdv = newRdv
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      cancel () {
        this.$router.goBack(this.$route)
      }
    },
    created () {
      if (this.$route.query.duplicateEvent) {
        this.getRdv(this.$route.query.duplicateEvent)
      }
      if (this.$route.query.reporter) {
        this.isReported = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarCreate.vue